import TermsAndConditions from './TermsAndConditions';

function App() {
  return <TermsAndConditions />;
}

export default App;
